import React, { useEffect, useState } from 'react';
import { Select, ThemeContext } from 'grommet';
import _ from 'lodash';
import './styles.module.scss';

const SingleSelectAtom = (props) => {
  const {
    field,
    layout,
    label,
    help,
    options = [],
    getOptions,
    onChange,
    value,
    disabled,
    ...rest
  } = props;

  const [optionsList, setOptions] = useState(options);
  const defaultOption = { label: 'Loading ...', value: 0 };

  useEffect(() => {
    setOptions(options.length ? options : [defaultOption]);
  }, [options]);

  const selectClass = {
    global: {
      colors: {
        background: disabled ? '#070707' : 'white',
      },
    },
    select: {
      icons: {
        color: disabled ? 'white' : 'black',
      },
    },
  };

  const handleChange = (opt) => {
    if (onChange) {
      onChange(opt);
    }
  };

  return (
    <ThemeContext.Extend value={selectClass}>
      <Select
        options={optionsList}
        {...field}
        {...rest}
        emptySearchMessage="No result found"
        onChange={handleChange}
        onSearch={(text) => {
          const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
          const exp = new RegExp(escapedText, 'i');
          setOptions(options.filter((o) => exp.test(o.label)));
        }}
        dropProps={{ style: { zIndex: 999 } }}
        dropHeight="medium"
        searchPlaceholder="Search..."
        labelKey="label"
        valueKey={{ key: 'value', reduce: true }}
        className={disabled ? 'select-disable' : ''}
        disabled={disabled}
      />
    </ThemeContext.Extend>
  );
};

export default SingleSelectAtom;
